/* eslint-disable no-undef */
import { useEffect } from 'react';

const useScript = (
	pageName: string,
	product: string,
	vertical: string,
	subproduct: string,
	category: string
) => {
	useEffect(() => {
		const script = document.createElement('script');

		window.customData = {
			page: {
				name: pageName,
				porto_product: product,
				porto_subproduct: subproduct,
				category: category,
				vertical: vertical,
			},
			site: {
				portal: 'hub-vendas',
				versao: '1.2',
				marca: 'porto-seguro',
			},
			user: {
				product_login: 'sem-produto',
				user_id: '',
				logged: false,
				client_bcp: '',
			},
		};

		script.append(window.customData);
		script.async = true;

		document.body?.appendChild(script);

		return () => {
			document.body?.removeChild(script);
		};
	}, []);
};

export default useScript;
